import React, { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import styles from "./ModernSlider.module.scss";
import { axiosInstance } from "../../../services";
import { useTranslation } from "react-i18next";
import { HeroBanner } from "../../common";
import LeaderboardBanner from "../../common/Banner/LeaderboardBanner";

const SLIDE_DURATION = 5000; // 5 seconds per slide

const ModernSlider = (props) => {
  const { path = "home" } = props;
  const {
    i18n: { language },
  } = useTranslation();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slides, setSlides] = useState([]);
  const [occasionalSlides, setOccasionalSlides] = useState([]);

  const nextSlide = useCallback(() => {
    // return;
    if (!slides?.length) return;
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % slides?.length);
    setTimeout(() => setIsAnimating(false), 500);
  }, [isAnimating, slides]);



  const fetchSliders = useCallback(async () => {
    const params1 = new URLSearchParams({ path, isActive: "true" });
    const params2 = new URLSearchParams({
      path: "occasional",
      isActive: "true",
    });

    const bannerRequest = axiosInstance.get(`/banners?${params1.toString()}`);

    const requests = [bannerRequest];

    if (path === "home") {
      const occasionalRequest = axiosInstance.get(
        `/banners?${params2.toString()}`
      );
      requests.push(occasionalRequest);
    }

    try {
      // Await both in parallel
      const responses = await Promise.all(requests);

      const bannerRes = responses?.[0];
      if (
        bannerRes?.status === "success" &&
        bannerRes?.data?.banners?.length > 0
      ) {
        setSlides(bannerRes?.data?.banners);
      }
      if (path === "home" && responses?.length > 1) {
        const occRes = responses?.[1];
        if (occRes?.status === "success" && occRes?.data?.banners?.length > 0) {
          setOccasionalSlides(occRes?.data?.banners);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setSlides([]); // fallback
    }
  }, [path]);

  useEffect(() => {
    let slideInterval;
    if (!isHovered && !isAnimating) {
      slideInterval = setInterval(nextSlide, SLIDE_DURATION);
    }
    return () => clearInterval(slideInterval);
  }, [nextSlide, isHovered, isAnimating]);

  useEffect(() => {
    fetchSliders();
  }, [fetchSliders, path]);

  if (slides?.length <= 0) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <Box
        className={styles.sliderContainer}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box className={styles.slideWrapper}>
          <Box
            className={styles.slidesContainer}
            style={{
              transform: `translateX(-${currentSlide * 33.333}%)`,
            }}
          >
            {slides?.map((slide, index) => (
              <HeroBanner
                slide={slide}
                key={index}
                index={index}
                currentSlide={currentSlide}
                isAnimating={isAnimating}
                language={language}
              />
            ))}
          </Box>
        </Box>
      </Box>
      {path === "home" && occasionalSlides?.length > 0 && (
        <LeaderboardBanner {...occasionalSlides?.[0]} />
      )}
    </Box>
  );
};

export default ModernSlider;
